/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Payment_UnpaidInputs */

const vi_order_payment_unpaid = /** @type {(inputs: Order_Payment_UnpaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa thanh toán`)
};

/**

* @param {Order_Payment_UnpaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_unpaid = /** @type {((inputs?: Order_Payment_UnpaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_UnpaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_unpaid(inputs)
});